/*
  THORO · filtros de disponibilidad y talla hechos por el tema.

  Los de Shopify no cuadran con lo que se puede comprar en línea:
  - Disponibilidad (filter.v.availability): con «En existencia» salían productos agotados en
    todas sus tallas y con «Agotado», productos que sí tienen tallas.
  - Talla (filter.v.option.talla): no revisa existencia, deja fuera los productos cuya opción no
    se llama «Talla» (Tamaño en los Fango, Talla del calzado, TALLAS…) y separa 27 de 27.0.
  Aquí las casillas usan filter.thoro.disponible y filter.thoro.talla, que Shopify ignora (el
  resto de los filtros y el orden siguen siendo de Shopify).

  Con alguno de los dos puesto se piden todas las tarjetas de la colección ya filtrada
  (sections/thoro-filtro-todos.liquid) y se dejan las que cumplen según los datos de cada
  tarjeta (snippets/product-grid-item.liquid: data-disponible, data-tallas = tallas disponibles,
  data-tallas-todas). Los resultados van en una sola página.
  - Talla elegida: solo productos con esa talla disponible. Con «Agotado» (solo), los que la
    tienen agotada.
  - Sin talla: «En existencia» = algo disponible; «Agotado» = nada disponible; las dos = todo.

  Con talla elegida, abajo sale «Otros que podrían interesarte» (ver recomendar()).

  collection-filters-form.js arma la URL con todo lo que lleve «filter.» en el nombre y
  vuelve a pintar rejilla y filtros; cuando lo hace, aquí se aplica otra vez.
*/
(function () {
  'use strict';

  var DISP = 'filter.thoro.disponible';
  var TALLA = 'filter.thoro.talla';
  var SECCION = 'thoro-filtro-todos';
  var CARGANDO = 'thoro-cargando';
  var peticion = 0;

  function leer() {
    var params = new URLSearchParams(window.location.search);
    var disp = params.getAll(DISP);
    var en = disp.indexOf('1') > -1;
    var ag = disp.indexOf('0') > -1;
    return {
      disp: disp,
      tallas: params.getAll(TALLA).map(normalizar),
      modo: en === ag ? null : en ? '1' : '0'
    };
  }

  // Igual que en Liquid: 27.0 = 27.
  function normalizar(valor) {
    return /\.0$/.test(valor) ? valor.slice(0, -2) : valor;
  }

  function cumple(tarjeta, f) {
    var disponibles = tarjeta.getAttribute('data-tallas') || '';
    var todas = tarjeta.getAttribute('data-tallas-todas') || '';
    var tiene = function (lista, talla) {
      return lista.indexOf('|' + talla + '|') > -1;
    };

    if (f.tallas.length) {
      if (f.modo === '0') {
        return f.tallas.some(function (t) { return tiene(todas, t) && !tiene(disponibles, t); });
      }
      return f.tallas.some(function (t) { return tiene(disponibles, t); });
    }
    if (f.modo) return tarjeta.getAttribute('data-disponible') === (f.modo === '1' ? 'true' : 'false');
    return true;
  }

  function marcarCasillas(f) {
    var activos = {};
    activos[DISP] = f.disp;
    activos[TALLA] = f.tallas;

    [DISP, TALLA].forEach(function (nombre) {
      document.querySelectorAll('input[name="' + nombre + '"]').forEach(function (input) {
        var activo = activos[nombre].indexOf(input.value) > -1;
        input.checked = activo;
        var item = input.closest('.sidebar__item');
        if (item) {
          item.classList.toggle('sidebar__item--active', activo);
          item.classList.toggle('link--remove', activo);
          item.classList.toggle('link--add', !activo);
          // Si la talla elegida estaba entre las escondidas de «Más opciones», que se vea.
          if (activo) item.classList.remove('hidden');
        }
      });
      document.querySelectorAll('[data-thoro-cuenta="' + nombre + '"]').forEach(function (el) {
        el.textContent = activos[nombre].length ? '(' + activos[nombre].length + ')' : '';
      });
    });

    // Contador junto a «Mostrar filtros»: el de Shopify más las casillas de aquí.
    var base = document.querySelector('[data-active-filters-count]');
    var total = (base ? parseInt(base.getAttribute('data-active-filters-count'), 10) || 0 : 0) +
      f.disp.length + f.tallas.length;
    document.querySelectorAll('[data-active-filters]').forEach(function (el) {
      el.textContent = total;
      el.classList.toggle('hidden', total < 1);
    });
  }

  function traerPagina(pagina, ruta) {
    var url = new URL(window.location.href);
    if (ruta) url.pathname = ruta;
    url.searchParams.delete('page');
    url.searchParams.set('section_id', SECCION);
    if (pagina > 1) url.searchParams.set('page', pagina);
    return fetch(url.toString())
      .then(function (r) {
        if (!r.ok) throw new Error('thoro-filtro-todos ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var caja = doc.querySelector('[data-thoro-todos]');
        return {
          paginas: caja ? parseInt(caja.getAttribute('data-paginas'), 10) || 1 : 1,
          tarjetas: caja ? Array.prototype.slice.call(caja.querySelectorAll('[data-grid-item]')) : []
        };
      });
  }

  function traerTodas(ruta) {
    return traerPagina(1, ruta).then(function (primera) {
      var resto = [];
      for (var p = 2; p <= primera.paginas; p++) resto.push(traerPagina(p, ruta));
      return Promise.all(resto).then(function (otras) {
        return otras.reduce(function (todas, o) {
          return todas.concat(o.tarjetas);
        }, primera.tarjetas);
      });
    });
  }

  function aplicar() {
    var rejilla = document.querySelector('[data-products-grid]');
    if (!rejilla) return;

    var f = leer();
    marcarCasillas(f);

    var id = ++peticion;
    if (!f.tallas.length) esconderRecomendados();
    if (!f.modo && !f.tallas.length) {
      rejilla.classList.remove(CARGANDO);
      return;
    }

    rejilla.classList.add(CARGANDO);
    traerTodas()
      .then(function (tarjetas) {
        if (id !== peticion) return;
        var contenedor = rejilla.querySelector('.grid');
        if (!contenedor) return;

        var buenas = tarjetas.filter(function (t) { return cumple(t, f); });

        if (buenas.length) {
          contenedor.innerHTML = buenas.map(function (t) { return t.outerHTML; }).join('');
        } else {
          var texto = rejilla.getAttribute('data-thoro-sin-resultados') || '';
          contenedor.innerHTML = '<div class="no-results"><p><strong></strong></p></div>';
          contenedor.querySelector('strong').textContent = texto;
        }

        // Todo cabe en una página: la paginación de Shopify ya no aplica.
        rejilla.querySelectorAll('.pagination-custom').forEach(function (nav) {
          nav.hidden = true;
        });
        rejilla.classList.remove(CARGANDO);
        if (f.tallas.length) recomendar(f, tarjetas, id);
      })
      .catch(function (error) {
        if (id === peticion) rejilla.classList.remove(CARGANDO);
        console.warn(error);
      });
  }

  // «Otros que podrían interesarte» (solo con talla elegida): productos del mismo género que la
  // colección —el que más se repite entre hombre y dama; unisex entra con los dos— que cumplen
  // los mismos filtros y no están en esta colección. Se buscan en /collections/all con los
  // mismos parámetros, así que tipo de prenda, precio y orden de Shopify también aplican.
  function esconderRecomendados() {
    var caja = document.querySelector('[data-thoro-recomendados]');
    if (!caja) return;
    caja.hidden = true;
    var rejilla = caja.querySelector('[data-thoro-recomendados-grid]');
    if (rejilla) rejilla.innerHTML = '';
  }

  function genero(tarjetas) {
    var cuenta = { HOMBRE: 0, DAMA: 0 };
    tarjetas.forEach(function (t) {
      var g = t.getAttribute('data-genero') || '';
      if (g.indexOf('|HOMBRE|') > -1) cuenta.HOMBRE++;
      if (g.indexOf('|DAMA|') > -1) cuenta.DAMA++;
    });
    if (cuenta.HOMBRE === cuenta.DAMA) return null;
    return cuenta.HOMBRE > cuenta.DAMA ? 'HOMBRE' : 'DAMA';
  }

  // Botón «Ver todo en talla …»: /collections/all con los mismos parámetros (talla, disponibilidad,
  // tipo de prenda, precio, orden) más el género de la colección y unisex, si no venía uno puesto.
  function botonCatalogo(caja, f, g) {
    var boton = caja.querySelector('[data-thoro-recomendados-boton]');
    if (!boton) return;
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    var GEN = 'filter.p.m.custom.genero2';
    if (!params.getAll(GEN).length) {
      params.append(GEN, g);
      params.append(GEN, 'UNISEX');
    }
    boton.href = '/collections/all?' + params.toString();
    var texto = (boton.getAttribute('data-texto') || '').replace('{talla}', f.tallas.join(', '));
    var span = boton.querySelector('span');
    (span || boton).textContent = texto;
  }

  function recomendar(f, tarjetasColeccion, id) {
    var caja = document.querySelector('[data-thoro-recomendados]');
    if (!caja || window.location.pathname.split('/').pop() === 'all') return esconderRecomendados();
    var g = genero(tarjetasColeccion);
    if (!g) return esconderRecomendados();

    var enColeccion = {};
    tarjetasColeccion.forEach(function (t) { enColeccion[t.getAttribute('data-product-id')] = true; });
    var max = parseInt(caja.getAttribute('data-max'), 10) || 12;

    traerTodas('/collections/all')
      .then(function (todas) {
        if (id !== peticion) return;
        var vistas = {};
        var elegidas = todas.filter(function (t) {
          var pid = t.getAttribute('data-product-id');
          var gen = t.getAttribute('data-genero') || '';
          if (enColeccion[pid] || vistas[pid]) return false;
          if (gen.indexOf('|' + g + '|') === -1 && gen.indexOf('|UNISEX|') === -1) return false;
          if (!cumple(t, f)) return false;
          vistas[pid] = true;
          return true;
        }).slice(0, max);

        if (!elegidas.length) return esconderRecomendados();
        caja.querySelector('[data-thoro-recomendados-grid]').innerHTML = elegidas
          .map(function (t) { return t.outerHTML; })
          .join('');
        botonCatalogo(caja, f, g);
        caja.hidden = false;
      })
      .catch(function (error) {
        if (id === peticion) esconderRecomendados();
        console.warn(error);
      });
  }

  function vigilar() {
    var rejilla = document.querySelector('[data-products-grid]');
    if (!rejilla) return;
    // El tema reemplaza el contenido de la rejilla al filtrar; los cambios de aquí van
    // dentro de .grid y no disparan esto.
    new MutationObserver(aplicar).observe(rejilla, { childList: true });
    aplicar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigilar);
  } else {
    vigilar();
  }
})();
